import { ComponentPropsWithoutRef, useRef } from "react";
import * as styles from "./SectionBlockMediaFeatured.css";
import { Testimonial, FeaturedImage } from "~/sanity/types";
import { WrapperContentMask } from "~/components/wrappers/WrapperContentMask";
import { Image, IImage } from "~/components/elements/Image";
import { CardCallout } from "~/components/components/cards/CardCallout";
import Grid from "~/components/globals/Grid";
import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { useGSAP } from "@gsap/react";

export type SectionBlockMediaFeaturedProps = ComponentPropsWithoutRef<"div"> & {
  data: Testimonial | FeaturedImage;
};

export const SectionBlockMediaFeatured = ({
  data,
}: SectionBlockMediaFeaturedProps) => {
  const { image, cardCallout } = data;
  const wrapperRef = useRef(null);
  const imageRef = useRef(null);

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapperRef.current,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        // markers: true,
      },
    });

    tl.to(imageRef.current, {
      yPercent: 15,
    });
  }, []);

  return (
    <section ref={wrapperRef} className={styles.section}>
      <WrapperContentMask className={styles.wrapper}>
        <div className={styles.imageContainer}>
          {image?.asset && (
            <>
              <div className={styles.imageWrapper} ref={imageRef}>
                <Image
                  image={image as IImage}
                  className={styles.backgroundImage}
                  width={1920}
                  // full
                  loading="eager"
                />
              </div>
            </>
          )}
        </div>

        {cardCallout && (
          <Grid className={styles.grid}>
            <div className={styles.cardContainer}>
              <CardCallout
                card={cardCallout}
                theme="colour"
                className={styles.card}
              />
            </div>
          </Grid>
        )}
      </WrapperContentMask>
    </section>
  );
};
